// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"07a6ab98","455":"35efd778","977":"66a75274"}[chunkId] + ".chunk.js";
};